import { Injectable } from '@angular/core';
import { OnboardingChecklistRoute, RoleType } from '../constants-types/Enums';
import { DateFormatUtility } from '../core-utilities/DateFormat.utility';
import { InitDataService } from '../system-services/InitData/InitData.service';
import { UserProfileSettingsService } from '../system-services/UserProfileSettings/UserProfileSettings.service';
import { TranslationService } from '../translations';

type OnboardingChecklistItems = {
    valueAccessor: string;
    route: string;
};
@Injectable({ providedIn: 'root' })
export class OnboardingService {
    private onboardingChecklistItems: OnboardingChecklistItems[];

    constructor(
        private TR: TranslationService,
        private initData: InitDataService,
        private userProfile: UserProfileSettingsService,
        private date: DateFormatUtility
    ) {
        // keep up to date with OnboardingChecklist type in UserProfileSetting.model.ts
        // takePITour field removed in 2019 sprint M, older clients may still have this field set
        // current code does not look for it or set it. May want to clean up database with DocDB
        this.onboardingChecklistItems = [
            {
                valueAccessor: 'initialLogin',
                route: OnboardingChecklistRoute.InitialLogin
            },
            {
                valueAccessor: 'connectBehavioral',
                route: OnboardingChecklistRoute.ConnectBehavioral
            },
            {
                valueAccessor: 'inviteEmployeesBA',
                route: OnboardingChecklistRoute.InviteEmployeesBA
            },
            {
                valueAccessor: 'addMoreUsers',
                route: OnboardingChecklistRoute.AddMoreUsers
            }
        ];
    }

    showOnboardingCard() {
        return (
            this.onBoardingAvailable() &&
            this.showCardOverLink() &&
            this.userProfile.onboarding === 'unstarted'
        );
    }

    showOnboardingLink() {
        return this.onBoardingAvailable() && !this.showCardOverLink();
    }

    private onBoardingAvailable() {
        return (
            this.initData.hasPermissionLevelOrAbove(RoleType.AccountAdmin) &&
            this.TR.isEnglish() &&
            this.initData.account.isOnboardingEnabled
        );
    }

    private showCardOverLink() {
        return (
            !this.date.isXDaysPastDate(
                this.userProfile.getPresumedStartDate(),
                60
            ) || this.initData.user.isNetworkUser
        );
    }

    findNextChecklistItem(): OnboardingChecklistItems {
        const nextStep = this.onboardingChecklistItems.find(
            (_) =>
                this.userProfile.onboardingChecklist[_.valueAccessor] ===
                    false ||
                this.userProfile.onboardingChecklist[_.valueAccessor] ===
                    'notDone'
        );
        // return the onboardingChecklist item or 'undefined' if none found that match search
        return nextStep;
    }

    showNextSteps(): boolean {
        return !this.findNextChecklistItem();
    }

    onboardingNextStepRoute(): string {
        if (this.showNextSteps()) {
            return '/onboarding/nextsteps';
        } else {
            return this.findNextChecklistItem().route;
        }
    }
}
